export function runnersOptions() {
  return [
    
    "Professional",
     "Competitive",
     "Recreational",
     "Hobby/ Run for a cause"


  ];
}